<!-- 注册邀请-如何运作 -->
<template>
  <div class=" bgBox ">
    <div class="conBox ">
      <div class="fontBox">
        <div class="fontCon">
          <div class="conH3">{{ $fanyi("优化产品搜索") }}</div>
          <div class="conH2">{{ $fanyi("简化流程，找到你想要的东西") }}</div>
          <div class="conCon">
            {{
              $fanyi(
                "通过图片或链接在1688上搜索，节省业务时间。你是我们的优先事项。"
              )
            }}
          </div>
        </div>
      </div>

      <div class="operationBox flex jcenter acenter">
        <div class="operationListBox">
          <div
            class="operationItemBox"
            :class="{ active: active == 0 }"
            @mouseenter="active = 0"
          >
            <div class="outIconBox"><icon1 :active="active == 0" /></div>

            <div class="operationItemFontBox">
              <label>{{ $fanyi("通过图片搜索") }}</label>

              <span>{{
                $fanyi(
                  "在Rakumart中，您可以通过图像搜索产品，优化您的搜索，以找到您想要进口的产品。"
                )
              }}</span>
            </div>
          </div>

          <div
            class="operationItemBox"
            :class="{ active: active == 1 }"
            @mouseenter="active = 1"
          >
            <div class="outIconBox"><icon2 :active="active == 1" /></div>

            <div class="operationItemFontBox">
              <label>{{ $fanyi("创建新订单") }}</label>
              <span>{{
                $fanyi(
                  "找到产品，进行定制并添加服务。您将收到一份包含中国发货运费的报价。"
                )
              }}</span>
            </div>
          </div>

          <div
            class="operationItemBox"
            :class="{ active: active == 2 }"
            @mouseenter="active = 2"
          >
            <div class="outIconBox"><icon3 :active="active == 2" /></div>

            <div class="operationItemFontBox">
              <label>{{ $fanyi("定制你的产品") }}</label>
              <span>{{
                $fanyi(
                  "你有 Logo 吗？定制包装和图片，让你的产品真正独一无二。"
                )
              }}</span>
            </div>
          </div>

          <div
            class="operationItemBox"
            :class="{ active: active == 3 }"
            @mouseenter="active = 3"
          >
            <div class="outIconBox"><icon4 :active="active == 3" /></div>

            <div class="operationItemFontBox">
              <!-- 报价和付款 -->
              <label>{{ $fanyi("报价和付款") }}</label>
              <span>{{
                $fanyi(
                  "我们将在48小时内报价您的订单和运输费用。Rakumart确保安全可靠的支付，保护您的数据在每一笔交易。"
                )
              }}</span>
            </div>
          </div>

          <div
            class="operationItemBox"
            :class="{ active: active == 4 }"
            @mouseenter="active = 4"
          >
            <div class="outIconBox"><icon5 :active="active == 4" /></div>

            <div class="operationItemFontBox">
              <label>{{ $fanyi("物流、发货和交付") }}</label>
              <span>{{
                $fanyi(
                  "付款后，我们将按照所选方式发货。"
                )
              }}</span>
            </div>
          </div>
        </div>
        <el-carousel
          ref="imgBoxRef"
          height="550px"
          direction="vertical"
          indicator-position="none"
          :autoplay="false"
          class="imgBox"
        >
          <el-carousel-item
            v-for="(item, index) in imgList"
            :key="index"
            class="acenter flex"
          >
            <img
              class="itemImg"
              :src="item"
              alt=""
              :class="{ img1: index == 0 }"
            />
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
  </div>
</template>
<script>
import icon1 from "./assets/icon1.vue";
import icon2 from "./assets/icon2.vue";
import icon3 from "./assets/icon3.vue";
import icon4 from "./assets/icon4.vue";
import icon5 from "./assets/icon5.vue";
export default {
  data() {
    return {
      active: 0,
      imgList: [
        "https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/20260618172224490815.png",
        "https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/2026061817222696535.png",
        "https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/202410/670f31644e16c.png",
        "https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/20260618172228354465.png",
        "https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/20260618172230755624.png",
      ],
    };
  },
  components: {
    icon1,
    icon2,
    icon3,
    icon4,
    icon5,
  },
  watch: {
    active(newVal, oldVal) {
      console.log(this.active, 222);
      this.$refs.imgBoxRef.setActiveItem(this.active);
    },
  },
  computed: {},
  created() {},
  methods: {},
};
</script>
<style lang="scss" scoped="scoped">
@import "@/css/mixin.scss";
* {
  // border: solid;
}
.bgBox {
  background: #fff;
}
.conBox {
  padding: 56px 0;
  .fontBox {
    text-align: center;
    margin: 0 auto 15px;
    width: 820px;
    .conH3 {
      color: var(--Rakumart-500, #009246);
      font-size: 20px;
      font-weight: 700;
      line-height: 30px; /* 150% */
      margin-bottom: 8px;
    }
    .conH2 {
      color: #013b2d;

      font-size: 36px;
      font-weight: 600;
      line-height: 44px; /* 122.222% */
      letter-spacing: -0.72px;
      margin-bottom: 16px;
    }
    .conCon {
      font-size: 18px;
      line-height: 24px; /* 150% */
    }
  }

  .operationBox {
    .operationListBox {
      width: 665px;
      .operationItemBox {
        @extend .dip;

        min-height: 50px;
        transition: 0.3s;
        margin-bottom: 35px;
        &:last-child {
          margin-bottom: 0;
        }
        * {
          transition: 0.3s;
        }
        .outIconBox {
          margin-right: 21.47px;
        }
        .operationItemFontBox {
          display: flex;
          flex: 1;
          flex-direction: column;
          label {
            color: #013b2d;
            font-size: 24px;
            font-weight: 600;
            line-height: 32px; /* 133.333% */
          }
          span {
            font-size: 18px;
            line-height: 28px; /* 155.556% */
            display: block;
            overflow: hidden;
            max-height: 0;
          }
        }
      }

      .operationItemBox.active {
        min-height: 104px;
        align-items: flex-start;
        .operationItemFontBox {
          label {
            margin-bottom: 16px;
          }
          span {
            max-height: 84px;
          }
        }
      }
    }

    .imgBox {
      margin-left: 80px;
      flex: 0 0 700px;
      text-align: right;
      .itemImg {
        // width: 616px;
        // height: 500px;
        background-position: center;
      }
      .itemImg.img1 {
        // width: 785px;
        // height: auto;
        // transform: translateY(-47px);
      }
    }
  }

  .bgBlueBtn {
    width: 320px;
    height: 60px;
    font-size: 18px;
    font-weight: 700;
  }
}
</style>
